import { IFilterGrid, IFilterGridItem } from '@/interfaces/constructor.interfaces';
import instanceOfGrid from '@/utils/instanceOfGrid';

/**
 * Возвращает массив фильтров, содержащихся, в гриде
 * @param grid грид с фильтрами
 * @param acc параметр - аккумулятор, для рекурсивного вызова
 */
function getFiltersFromGrid(grid: IFilterGrid): Array<IFilterGridItem> {
  let acc: IFilterGridItem[] = [];

  grid.items.forEach(item => {
    if (instanceOfGrid(item)) {
      const subGridItems = getFiltersFromGrid(item as IFilterGrid);

      acc = [...acc, ...subGridItems];
      return;
    }

    acc.push(item);
  });

  return acc;
}

export default getFiltersFromGrid;
